class FpCountdown extends HTMLElement {
  connectedCallback() {
    const hours = parseFloat(this.dataset.durationHours || '6');
    const storageKey = `fp-countdown-${this.dataset.key || 'default'}`;
    let deadline = parseInt(sessionStorage.getItem(storageKey) || '0', 10);

    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + hours * 60 * 60 * 1000;
      sessionStorage.setItem(storageKey, String(deadline));
    }

    this.hoursEl = this.querySelector('[data-fp-hours]');
    this.minutesEl = this.querySelector('[data-fp-minutes]');
    this.secondsEl = this.querySelector('[data-fp-seconds]');

    this.tick(deadline);
    this.interval = setInterval(() => this.tick(deadline), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick(deadline) {
    const remaining = Math.max(0, deadline - Date.now());
    const h = Math.floor(remaining / 3600000);
    const m = Math.floor((remaining % 3600000) / 60000);
    const s = Math.floor((remaining % 60000) / 1000);

    if (this.hoursEl) this.hoursEl.textContent = String(h).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(m).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(s).padStart(2, '0');

    if (remaining <= 0) clearInterval(this.interval);
  }
}

customElements.define('fp-countdown', FpCountdown);
